const errorHandler = (error, emptyResult = null) => {
  const { response } = error;
  if (!response) {
    return "Cannot connect to the server, Check your internet network";
  } else if (response && response.status) {
    const message = response?.data?.message || response?.data?.errMsg;
    const errorText = message;
    return errorText;
  } else {
    return "An unknown error occurred in the app, please try again. ";
  }
};

export default errorHandler;
